import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Select from '../inputs/Select';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.Country.placeholder',
        defaultMessage: 'Country',
    },
});

const Country = ({
    value,
    options,
    fieldSize,
    isBlurred,
    disabled,
    disableAutocomplete,
    error,
    onChange,
    onBlur = () => {},
}) => {
    const intl = useIntl();
    return (
        <Select
            name="country"
            dataTn="country"
            placeholder={intl.formatMessage(messages.placeholder)}
            value={value}
            wrapperClass={styles.group}
            options={options}
            searchable
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            disableAutocomplete={disableAutocomplete}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

Country.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    options: PropTypes.array.isRequired,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
    disableAutocomplete: PropTypes.bool,
};

export default Country;
